const colors = {
  dark: "#481614",
  secondaryDark: "#84240C",
  main: "#FF3C00",
  secondary: "#AF5234",
};

export default colors;
